import React from 'react';
import PropTypes from 'prop-types';
import { OfferMoreGigsContextProvider } from '../components/OfferMoreGigs/context';
import { StaticContextProvider } from './contexts/static';
import { AttachmentsContextProvider } from './contexts/attachments';
import { MessageContextProvider } from './contexts/message';
import { ValidationContextProvider } from './contexts/validation';
import { ReportContextProvider } from './contexts/reporting';
import {
    BriefInfo,
    RecipientInfo,
    SenderInfo,
    VacationInfo
} from './propTypes';
import { SendBatchBriefContextProvider } from './contexts/sendBatchBrief';

export const ContextProvider = ({ children, ...props }) => (
    <StaticContextProvider {...props}>
        <ReportContextProvider>
            <AttachmentsContextProvider>
                <MessageContextProvider>
                    <SendBatchBriefContextProvider>
                        <OfferMoreGigsContextProvider>
                            <ValidationContextProvider>
                                {children}
                            </ValidationContextProvider>
                        </OfferMoreGigsContextProvider>
                    </SendBatchBriefContextProvider>
                </MessageContextProvider>
            </AttachmentsContextProvider>
        </ReportContextProvider>
    </StaticContextProvider>
);

ContextProvider.propTypes = {
    recipientInfo: RecipientInfo,
    relatedGigId: PropTypes.number,
    professionRelatedTranslationKey: PropTypes.string,
    pageName: PropTypes.string,
    source: PropTypes.string,
    showInfo: PropTypes.bool,
    showSpokenLanguages: PropTypes.bool,
    showCountryFlag: PropTypes.bool,
    sendMessage: PropTypes.func,
    children: PropTypes.node.isRequired,
    getMoreGigsData: PropTypes.func,
    offerMoreGigsEnabled: PropTypes.bool,
    isRequestToOrderModal: PropTypes.bool,
    encourageAppDownloadEnabled: PropTypes.bool,
    senderInfo: SenderInfo,
    brief: BriefInfo,
    vacation: VacationInfo,
    withSatisfactionGuarantee: PropTypes.bool
};
